import script from "./report-data.vue?vue&type=script&lang=ts&setup=true"
export * from "./report-data.vue?vue&type=script&lang=ts&setup=true"

import "./report-data.vue?vue&type=style&index=0&id=5e5e5788&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\yang'ya'fei\\Documents\\tianshu-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e5e5788"]])

export default __exports__